<template lang="pug">
    v-layout(row wrap align-center justify-center)
        v-flex.px-3(xs8 md8)
            v-alert(:key='index' v-for="(validation,index) in arrayValidations" :value="true" type="error")
                .subheading {{validation.text}}
            //v-flex.px-3(xs8 md8)
                span {{arrayValidations}}
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'validations',
    props: {},
    data: function(){
        return {
            // arrayValidations:[
            //     {id:1, text: 'Malo 1 daifajp nfpav jadpo nvdaip v'},
            //     {id:2, text: 'Malo 2 cqaofi f '},]
        }
    },
    computed: {
        ...mapGetters('WholesaleDiscountModule', {
            arrayValidations: 'arrayValidations'
        })
    },
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>